let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c8IeZ")).then(() => parcelRequire('kLLtw'));